<template>
  <div>
    <p>
      The
      <a :href="links.mfsHome" target="_blank" rel="noopener noreferrer">Maine Forest Service</a>
      is available to answer questions and assist landowners with planning
      your forest management activities. Maine Forest Service strongly recommends that you:
    </p>
    <ul class="summary-list list-none">
      <li>
        <span class="px-2">
          <FontAwesomeIcon icon='check' />
        </span>
        Check with the town or municipality about any local ordinances that may apply to your
        activity.
      </li>
      <li>
        <span class="px-2">
          <FontAwesomeIcon icon='check' />
        </span>
        Be familiar with <strong>ALL</strong> rules that apply to your activity
        <strong>BEFORE</strong> you begin your activities.
      </li>
      <li>
        <span class="px-2">
          <FontAwesomeIcon icon='check' />
        </span>
        Plan your harvest well in advance!
      </li>
    </ul>
    <hr class="border-dark">
    <HarvestReminders />
    <hr class="border-dark">
    <RoadReminders />
    <hr class="border-dark">
    <WaterCrossingReminders />
    <hr class="border-dark">
    <GeneralReminders />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HarvestReminders from '@/components/notification/summary/HarvestReminders.vue';
import GeneralReminders from '@/components/notification/summary/GeneralReminders.vue';
import RoadReminders from '@/components/notification/summary/RoadReminders.vue';
import WaterCrossingReminders from '@/components/notification/summary/WaterCrossingReminders.vue';

export default {
  name: 'ImportantReminders',
  components: {
    HarvestReminders,
    GeneralReminders,
    RoadReminders,
    WaterCrossingReminders,
  },
  computed: {
    ...mapState('Configuration', {
      links: state => state.links,
    }),
  },
  methods: {
    reload() {
      this.$store.dispatch('Notification/fetchImportantReminders');
    },
  },
};
</script>
